export default __webpack_public_path__ + "045a7d77fed1e9d388c91d863e5487e3.png";